const time_secs_format = (s, i) => `${s>=3600?Math.floor(s/3600)+'h ':''}${s>=60?Math.floor((s%3600)/60)+'m ':''}${(s%60).toFixed(i)}s`

export default time_secs_format